import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { Button, Modal } from '@repo/ui';

interface Props {
  open: boolean;
  testId: TestId;
  onConfirm: () => void;
  onCancel: () => void;
  pending: boolean;
}

export default function AuthConversionConflictModal({ open, testId, onConfirm, onCancel, pending }: Props) {
  return (
    <Modal open={open} onOpenChange={(next) => !next && onCancel()} testId={testId} width="sm">
      <div className="flex flex-col gap-4 py-4">
        <h2 className="text-heading text-xl font-semibold">{tr('auth:login_drawer.conversion_conflict.title')}</h2>
        <p className="text-body text-sm">{tr('auth:login_drawer.conversion_conflict.description')}</p>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          <Button color="secondary" onClick={onCancel} testId={testId.append('cancel')} disabled={pending}>
            {tr('auth:login_drawer.conversion_conflict.cancel')}
          </Button>
          <Button color="brand" onClick={onConfirm} testId={testId.append('confirm')} pending={pending}>
            {tr('auth:login_drawer.conversion_conflict.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
